/** Cosmetic identity only; never an organization or authorization selector. */
export type TenantBrand = Readonly<{organizationId:string;slug:string;displayName:string}>;

// Preserve the existing PR170 identity mapping. No unverified logo or palette.
const carolinaServer:TenantBrand=Object.freeze({
  organizationId:'92900000-0000-4000-8000-000000000001',
  slug:'carolina-server',
  displayName:'CarolinaServer.com Operations',
});

export function tenantBrandBySlug(slug:string|null|undefined):TenantBrand|null {
  return slug===carolinaServer.slug?carolinaServer:null;
}

export function tenantBrandByOrganizationId(organizationId:string|null|undefined):TenantBrand|null {
  return organizationId===carolinaServer.organizationId?carolinaServer:null;
}
